import { SvgTypesProps } from "@/shared/types/SvgTypes";


export function IconWarning({
  fill = 'var(--steel-20)',
  width = 16,
  height = 16,
}: SvgTypesProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.79583 1.35494L0.931748 9.47514C0.831461 9.64881 0.778398 9.84572 0.777837 10.0463C0.777275 10.2468 0.829235 10.444 0.928547 10.6182C1.02786 10.7925 1.17106 10.9377 1.34391 11.0394C1.51675 11.1411 1.71322 11.1958 1.91375 11.198H11.6419C11.8424 11.1958 12.0389 11.1411 12.2118 11.0394C12.3846 10.9377 12.5278 10.7925 12.6271 10.6182C12.7264 10.444 12.7784 10.2468 12.7778 10.0463C12.7773 9.84572 12.7242 9.64881 12.6239 9.47514L7.75984 1.35494C7.65746 1.18616 7.51331 1.04662 7.3413 0.949782C7.1693 0.852939 6.97523 0.802063 6.77783 0.802063C6.58043 0.802063 6.38637 0.852939 6.21436 0.949782C6.04235 1.04662 5.8982 1.18616 5.79583 1.35494Z"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.77783 4.3067V6.60379"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.77783 8.90088H6.78357"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
